<div class="d-flex flex-column align-items-center justify-content-center py-16">
	<h1 class="title mb-3">Oops! You're lost</h1>
	<h3 class="m-0 mb-4">It looks like you're trying to access a page that either has been deleted or never existed</h3>
	<a [routerLink]="homeRoute" class="btn btn-outlined">Back home</a>
</div>
